const DataSection = {
    Sensor: { key: 'sensor', name: 'Sensor', shortName: 'R' },
    Tagging: { key: 'tagging', name: 'Tagging', shortName: 'T' },
    Scoring: { key: 'scoring', name: 'Scoring', shortName: 'S' },
    ScoringType: { key: 'scoringType', name: 'Scoring Type', shortName: 'ST' },
};

export default DataSection;